import ru from "date-fns/locale/ru";
import { formatUtcOffset, parseDateString } from "helpers/date";
import { REPORT_TYPES } from "helpers/reports";
import moment from "moment";
import React from "react";
import DatePicker from "react-datepicker";
import InputMask from "react-input-mask";

export default function PeriodFilter(props) {
    const {
        id,
        hourlyAnalyzeEnabled,
        setDateValue,
        values: { startDate, endDate },
        organizationTimezone,
    } = props;

    const formatValue = (value) => {
        const momentObj = moment(value);
        return momentObj.isValid() ? momentObj.toDate() : null;
    };

    const formattedStartDate = formatValue(startDate);
    const formattedEndDate = formatValue(endDate);

    const onChangeRaw = (name, e) => {
        const newVal = parseDateString(e.target.value);
        if (hourlyAnalyzeEnabled && newVal) {
            const startOfHour = moment(newVal).startOf("h");
            setDateValue(name, startOfHour.diff(moment(newVal), "minutes") === 0 ? newVal : startOfHour.add(1, "h"));
        }
        setDateValue(name, newVal);
    };

    const offset = formatUtcOffset(organizationTimezone);

    const periodFields = (
        <>
            {!props.withoutLabel && <div className="mb-md-0 col-form-label-sm report__filters--label">Период</div>}
            <div className="mb-md-0 report__filters--mr d-inline-flex align-items-center">
                <DatePicker
                    customInput={<InputMask mask="99.99.9999 99:99" />}
                    {...(hourlyAnalyzeEnabled
                        ? {
                              showTimeSelect: true,
                              timeCaption: "Время",
                              timeIntervals: 60,
                              timeFormat: "HH:mm",
                              onChangeRaw: onChangeRaw.bind(null, "startDate"),
                          }
                        : {})}
                    disabledKeyboardNavigation
                    className="form-control form-control-sm w-130"
                    onChange={setDateValue.bind(null, "startDate")}
                    onChangeRaw={onChangeRaw.bind(null, "startDate")}
                    name="startDate"
                    dateFormat="dd.MM.yyyy HH:mm"
                    selected={formattedStartDate}
                    locale={ru}
                    minDate={props.minStartDate}
                    placeholderText="Начало"
                />
                {offset && <span className="pl-2 font-size-12 text-muted">({offset})</span>}
            </div>
            <div className="mb-md-0 col-form-label-sm report__filters--label report__filters--hidden">&mdash;</div>
            <div className="mb-md-0 report__filters--mr d-inline-flex align-items-center">
                <DatePicker
                    customInput={<InputMask mask="99.99.9999 99:99" />}
                    {...(hourlyAnalyzeEnabled
                        ? {
                              showTimeSelect: true,
                              timeCaption: "Время",
                              timeIntervals: 60,
                              timeFormat: "HH:mm",
                              onChangeRaw: onChangeRaw.bind(this, "endDate"),
                          }
                        : {})}
                    disabledKeyboardNavigation
                    className="form-control form-control-sm w-130"
                    onChange={setDateValue.bind(this, "endDate")}
                    onChangeRaw={onChangeRaw.bind(this, "endDate")}
                    name="endDate"
                    dateFormat="dd.MM.yyyy HH:mm"
                    selected={formattedEndDate}
                    locale={ru}
                    placeholderText="Конец"
                    minDate={formattedStartDate}
                    maxDate={
                        id === REPORT_TYPES.DailyVehicleMileageReport && formattedStartDate
                            ? moment(formattedStartDate).add(40, "d").toDate()
                            : undefined
                    }
                />
                {offset && <span className="pl-2 font-size-12 text-muted pr-2">({offset})</span>}
            </div>
        </>
    );

    return id === REPORT_TYPES.AccountsReceivableReport ? (
        <div className="d-inline-flex flex-nowrap align-items-center flex-shrink-0">{periodFields}</div>
    ) : (
        periodFields
    );
}
